import { Box, Card, CardContent, Container, Grid } from "@mui/material";
import {
  InfoOperater,
  JavniKljuc,
  Loading,
  Poruka,
  PreuzimanjeJavniKljuc,
  PreuzimanjeUputaCSR,
  RegistarskiBroj,
} from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import { useMojiPodaci } from "../../hooks";

interface FormValues {
  certifikat: Blob | null;
  loading: Boolean;
  infoPoruka?: string;
  tipInfoPoruke?: number;
}

const defaultValues = {
  certifikat: null,
  loading: false,
};

const Index = () => {
  const methods = useForm<FormValues>({ defaultValues });
  const { operaterPlatforme, drzave } = useMojiPodaci(methods);

  return (
    <FormProvider {...methods}>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box component={"form"}>
              <InfoOperater />
              <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <RegistarskiBroj />
                    </Grid>
                    <Grid item xs={12}>
                      <PreuzimanjeUputaCSR />
                    </Grid>
                    <Grid item xs={12}>
                      <JavniKljuc />
                    </Grid>
                    <Grid item xs={12}>
                      <PreuzimanjeJavniKljuc />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Loading />
      <Poruka refreshPageOnClose={true} />
    </FormProvider>
  );
};

export default Index;
